import { MessageInfo } from "../../../types/info";
import { KeyMeasurementsAction } from "../../../types/actions";
import { GetKeyMeasurementsResponse } from "../../../../../server/types/request/report/key-mesurements";

export type State = {
	loading: boolean;
	info: MessageInfo;
} & GetKeyMeasurementsResponse;

export const initState: State = {
	data: [],
	job: undefined,
	loading: true,
	info: {
		isSuccess: true,
		message: "",
	},
};

export const reducer = (state: State, action: KeyMeasurementsAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case "changeMessageInfo":
			return {
				...state,
				loading: false,
				info: action.payload,
			};
		case "changeLoading":
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};
